import { AbstractControl, UntypedFormGroup } from '@angular/forms';

export function getFormControlName(control: AbstractControl): string {
  const group = (control as UntypedFormGroup).parent;

  if (!group) {
    return null;
  }

  for (const key of Object.keys(group.controls)) {
    if (group.get(key) === control) {
      return key;
    }
  }

  return null;
}
